export const ERROR_RESPONSE_STATUS = {
  ACTION_PERFORMED: "ACTION_PERFORMED",
  DUPLICATE_ACTION: "DUPLICATE_ACTION",
  APPLICATION_CANCELLED: "APPLICATION_CANCELLED",
  NO_ACTION_RECEIVED_FROM_MDO: "NO_ACTION_RECEIVED_FROM_MDO",
  LOAN_ID_NOT_FOUND: "LOAN_ID_NOT_FOUND",
  IDENTITY_ID_NOT_FOUND: "IDENTITY_ID_NOT_FOUND",
  INVALID_REASON_TYPE: "INVALID_REASON_TYPE",
  INVALID_USER_TYPE: "INVALID_USER_TYPE",
  INVALID_REASONS: "INVALID_REASONS",
  EMPLOYEE_ID_MISSING: "EMPLOYEE_ID_MISSING",
  REQUEST_ID_MISSING: "REQUEST_ID_MISSING",
  MERCHANT_NOT_UNDER_FIELD_FORCE: "MERCHANT_NOT_UNDER_FIELD_FORCE",
  ERROR_BK_MW: "ERROR_BK_MW",
  ERROR_DEXTER: "ERROR_DEXTER",
};

export const successStatuses = [
  ERROR_RESPONSE_STATUS.ACTION_PERFORMED,
  ERROR_RESPONSE_STATUS.DUPLICATE_ACTION,
  ERROR_RESPONSE_STATUS.APPLICATION_CANCELLED,
];

const LOAN_CONFIRMATION_ACTION_CONFIG = {
  recommend: {
    title: "Recommendation Confirmation",
    message:
      "Are you sure you want to recommend this loan request? Please select the reasons for this rejection.",
    buttonText: "Recommend",
    buttonClass: "btn--recommend",
  },
  retry: {
    title: "Retry Confirmation",
    message: "Are you sure you want to retry this loan request?",
    buttonText: "Retry",
    buttonClass: "btn--recommend",
  },
  reject: {
    title: "Rejection Confirmation",
    message:
      "Are you sure you want to reject this loan request? Please select the reasons for this rejection.",
    buttonText: "Reject",
    buttonClass: "btn--reject",
  },
};

export const getLoanConfirmationUi = (action) =>
  LOAN_CONFIRMATION_ACTION_CONFIG[action] ||
  LOAN_CONFIRMATION_ACTION_CONFIG.reject;
